import { render, staticRenderFns } from "./DireccionExterna.vue?vue&type=template&id=f1f4ef26&"
import script from "./DireccionExterna.vue?vue&type=script&lang=ts&"
export * from "./DireccionExterna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports